export default __webpack_public_path__ + "media/gallery/wrangler-fe0f3610.jpg";